import { render, staticRenderFns } from "./SGoodsCate.vue?vue&type=template&id=40f1f790&scoped=true"
import script from "./SGoodsCate.vue?vue&type=script&lang=js"
export * from "./SGoodsCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1f790",
  null
  
)

export default component.exports